import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'

// Styles
import classes from './AdminCustomer.scss'

// Actions
import { userActions } from 'redux/actionCreators'

// Components
import { Heading, RadioButtonGroup, Searchbox, Pagination } from 'components'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Link } from 'react-router'
import 'react-select/dist/react-select.css'

// Helpers
import _get from 'lodash.get'
import _omitBy from 'lodash.omitby'
import _isNil from 'lodash.isnil'
import { hasChanged, query } from 'helpers/utilities'

const STATUSES = {
  active: 'ผ่าน',
  pending: 'ยังไม่ระบุ',
  rejected: 'ไม่ผ่าน'
}
const CLASSES = ['ทั่วไป', 'ขายส่งระดับ 1', 'ขายส่งระดับ 2', 'ขายส่งระดับ 3', 'ขายส่งระดับ 4']

const SEARCH_BY_OPTIONS = [
  { title: 'Class', value: 'class' },
  { title: 'ตามเงื่อนไข', value: 'keyword' },
  { title: 'ค้นหาทุกรายการ', value: 'time' }
]

const CLASS_OPTIONS = [
  { title: 'ลูกค้าทั้งหมด', value: 'all' },
  { title: 'ทั่วไป', value: '0' },
  { title: 'ขายส่งระดับ 1', value: '1' },
  { title: 'ขายส่งระดับ 2', value: '2' },
  { title: 'ขายส่งระดับ 3', value: '3' },
  { title: 'ขายส่งระดับ 4', value: '4' }
]

const mapStateToProps = (state) => ({
  users: _get(state, ['user', 'users']) || [],
  pageCount: _get(state, ['user', 'pageCount']) || 0
})
const mapDispatchToProps = (dispatch) => ({
  attemptFindUsers: (payload) =>
    dispatch(userActions.attemptFindUsers(payload)),
  attemptRemoveUser: (payload) =>
    dispatch(userActions.attemptRemoveUser(payload)),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
})

@connect(mapStateToProps, mapDispatchToProps)
class AdminCustomers extends Component {
  static propTypes = {
    users: PropTypes.array.isRequired,
    pageCount: PropTypes.number.isRequired,
    attemptFindUsers: PropTypes.func.isRequired
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props)
    this.state = {
      searchBy: 'class'
    }
  }

  componentDidMount () {
    this._findCustomers(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (hasChanged(this.props, nextProps, ['location', 'query'])) {
      this._findCustomers(nextProps)
    }
  }

  _findCustomers = (props) => {
    const query = _get(props, ['location', 'query']) || {}

    this.props.attemptFindUsers(_omitBy({
      offset: (parseInt(query.page || 1, 10) - 1) * 100,
      limit: 100,
      userClass: query.class || undefined,
      userId: query.keyword || undefined,
      email: query.keyword || undefined,
      contactPersonName: query.keyword || undefined,
      pharmacyName: query.keyword || undefined,
      mobile: query.keyword || undefined,
      startDate: query.startDate || undefined,
      endDate: query.endDate || undefined
    }, _isNil))
  }

  _onSearchByChange = (value) =>
    this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=${value}`);

  _onClassChange = (userClass) => {
    this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=class&class=${userClass}`)
  };

  _onDateChange = (field, date) => {
    this.setState({ [field]: date })
  };

  _onSearchDate = () => {
    const pathname = _get(this.props, ['location', 'pathname'])
    const startDate = this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : ''
    const endDate = this.state.endDate ? this.state.endDate.format('YYYY-MM-DD') : ''
    this.context.router.push(`${pathname}?searchBy=time&startDate=${startDate}&endDate=${endDate}`)
  }

  _onEditCustomer = (userId) => {
    this.context.router.push(`/admin/customers/${userId}`)
  }

  _onRemoveCustomer = (userId) =>
    this.setState({ visible: true, removedUserId: userId })

  _onConfirmRemoveCustomer = () =>
    this.setState({ visible: false }, () => this.props.attemptRemoveUser({ userId: this.state.removedUserId }))

  _renderDesktopRow = ({ userId, referenceId, email, pharmacyName, mobile, status, userClass }) => (
    <tr key={userId}>
      <td className='text-center'>{userId}</td>
      <td className='text-center'>{referenceId || '-'}</td>
      <td>{email}</td>
      <td>{pharmacyName}</td>
      <td>{mobile}</td>
      <td className='text-center'>{STATUSES[status]}</td>
      <td className='text-center'>{CLASSES[userClass]}</td>
      <td className='text-center'>
        <img src='/images/icon-pencil-orange.png' alt='icon-pencil-orange' onClick={() => this._onEditCustomer(userId)} />
      </td>
      <td className='text-center'>
        <img src='/images/icon-bin-orange.png' alt='icon-bin-orange' onClick={() => this._onRemoveCustomer(userId)} />
      </td>
    </tr>
  )

  _renderMobileRow = ({ userId, referenceId, email, pharmacyName, mobile, status, userClass }) =>
    <div key={userId} className='row'>
      <Link to={`/admin/customers/${userId}`}>
        <div className='line'>
          <strong>รหัสลูกค้า</strong>
          <span>{userId}</span>
        </div>
        <div className='line'>
          <strong>รหัสใน CW</strong>
          <span>{referenceId || '-'}</span>
        </div>
        <div className='line'>
          <strong>อีเมล์</strong>
          <span>{email || '-'}</span>
        </div>
        <div className='line'>
          <strong>ชื่อร้าน/บริษัท</strong>
          <span>{pharmacyName}</span>
        </div>
        <div className='line'>
          <strong>เบอร์โทร</strong>
          <span>{mobile || '-'}</span>
        </div>
        <div className='line'>
          <strong>สถานะ</strong>
          <span>{STATUSES[status]}</span>
        </div>
        <div className='line'>
          <strong>คลาส</strong>
          <span>{CLASSES[userClass]}</span>
        </div>
      </Link>
      <img className='rowArrow' src='/images/icon-arrow-right.png' alt='icon-arrow-right' />
    </div>

  render () {
    const { users, pageCount, location } = this.props
    return (
      <section className={classes.customers}>
        <Heading>ค้นหา</Heading>
        <div className='text-center'>
          <RadioButtonGroup name='searchBy'
            selectedValue={query(this.props, 'searchBy') || 'class'}
            onChange={this._onSearchByChange}
            options={SEARCH_BY_OPTIONS} />
        </div>
        <div className='search-box'>
          {(query(this.props, 'searchBy') || 'class') === 'class' && (
            <RadioButtonGroup name='status'
              selectedValue={query(this.props, 'class') || 'all'}
              onChange={this._onClassChange}
              options={CLASS_OPTIONS} />
          )}
          {query(this.props, 'searchBy') === 'keyword' && (
            <Searchbox description='ค้นหาลูกค้าได้จาก รหัสลูกค้า, ชื่อ, อีเมล, เบอร์โทร, ชื่อร้าน/บริษัท'
              keyword={query(this.props, 'keyword')}
              onSearch={(keyword) => this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=keyword&keyword=${keyword}`)} />
          )}
          {query(this.props, 'searchBy') === 'time' && (
            <div className='time-range-selector'>
              <span>ข้อมูลระหว่าง วันที่</span>
              <div className='date-picker-container'>
                <DatePicker dateFormat='DD-MM-YYYY' selected={this.state.startDate} onChange={(date) => this._onDateChange('startDate', date)} />
                <img className='calendar' src='/images/icon-calendar-orange.png' role='presentation' />
              </div>
              <span style={{ marginLeft: '15px' }}>ถึง</span>
              <div className='date-picker-container'>
                <DatePicker dateFormat='DD-MM-YYYY' selected={this.state.endDate} onChange={(date) => this._onDateChange('endDate', date)} />
                <img className='calendar' src='/images/icon-calendar-orange.png' role='presentation' />
              </div>
              <div className='btn-time-range-search' onClick={this._onSearchDate}>
                <img src='/images/icon-search-white.png' alt='icon-search-white' />
                <span className='mobile'>ค้นหา</span>
              </div>
            </div>
          )}
        </div>
        <div>
          <Pagination router={this.context.router} location={location} pageCount={pageCount} />
        </div>
        <table className='with-stripe desktop'>
          <thead>
            <tr>
              <th>รหัสลูกค้า</th>
              <th>รหัสใน CW</th>
              <th>อีเมล์</th>
              <th>ชื่อร้าน/บริษัท</th>
              <th>เบอร์โทร</th>
              <th>สถานะ</th>
              <th>คลาส</th>
              <th>แก้ไข</th>
              <th>ลบ</th>
            </tr>
          </thead>
          <tbody>{users.map(this._renderDesktopRow)}</tbody>
          {!users.length && <tr><td className='text-center' colSpan='8'>ยังไม่มีรายชื่อลูกค้า</td></tr>}
        </table>
        <section className='list'>
          {users.map(this._renderMobileRow)}
        </section>
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
        {this.state.visible && (
          <div className={classes.overlay}>
            <div className={classes.modal}>
              <div className={classes.title}>คุณต้องการลบลูกค้าคนนี้ ?</div>
              <div>
                <div className={`${classes.btn} ${classes.btnRemove}`} onClick={this._onConfirmRemoveCustomer}>ตกลง</div>
                <div className={`${classes.btn} ${classes.btnCancel}`} onClick={() => this.setState({ visible: false, removedUserId: null })}>ยกเลิก</div>
              </div>
            </div>
          </div>
        )}
      </section>
    )
  }
}

export default AdminCustomers



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminCustomer/AdminCustomers.js